// @flow
import { APP_NAMESPACE } from "shared/constants/application";

const namespace: string = `${APP_NAMESPACE}/me`;

export const GET_ME_REQUEST: string = `${namespace}/ME/FETCH/REQUEST`;
export const GET_ME_REQUEST_SUCCESS: string = `${namespace}/ME/FETCH/SUCCESS`;
export const GET_ME_REQUEST_ERROR: string = `${namespace}/ME/FETCH/ERROR`;
